import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#2C3E50] text-white py-12 px-4 font-['Lato',sans-serif]" data-id="element-313">
        <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-314">
          <div className="space-y-2" data-id="element-315">
            <h3 className="font-['Montserrat',sans-serif] font-bold text-xl tracking-wider" data-id="element-316">
              NUVORA PLUS™
            </h3>
            <p className="text-sm text-gray-300 max-w-md mx-auto" data-id="element-317">
              El sistema de reconexión N°1 para parejas en crisis en Argentina.
              Porque salvar tu relación no debería llevarte meses de búsqueda.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-300" data-id="element-318">
            <a href="mailto:soportenuvoraplus@gmail.com" className="hover:text-[#27AE60] transition-colors" data-id="element-319">
              📧 soportenuvoraplus@gmail.com
            </a>
            <span className="hidden md:inline" data-id="element-320">·</span>
            <span data-id="element-321">📲 @nuvoraplus</span>
            <span className="hidden md:inline" data-id="element-322">·</span>
            <span data-id="element-323">🌐 www.reset24.nuvoraplus.online</span>
          </div>

          <div className="pt-6 border-t border-gray-600 flex flex-col sm:flex-row items-center justify-center gap-4 text-xs text-gray-400" data-id="element-324">
            <span data-id="element-325">© Nuvora Plus™ 2025 — Todos los derechos reservados.</span>
            <span className="hidden sm:inline" data-id="element-326">·</span>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-[#27AE60] transition-colors underline underline-offset-2" data-id="element-327">
              Política de Privacidad
            </button>
            <span className="hidden sm:inline" data-id="element-328">·</span>
            <button onClick={() => setShowTerms(true)} className="hover:text-[#27AE60] transition-colors underline underline-offset-2" data-id="element-329">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm font-['Montserrat',sans-serif] font-bold text-gray-300 pt-4 italic" data-id="element-330">
            "El próximo día puede ser diferente."
          </p>
        </div>
      </footer>

      {/* PRIVACY POLICY MODAL */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-331">
        <p data-id="element-332">
          <strong data-id="element-333">Última actualización:</strong> Marzo 2026
        </p>

        <p data-id="element-334">
          En NuvoraPlus, nos comprometemos a proteger tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-335">
          1. Información que recopilamos
        </h3>
        <p data-id="element-336">
          Recopilamos la información que nos proporcionás al realizar una
          compra, incluyendo tu nombre, dirección de correo electrónico y datos
          de pago procesados de forma segura a través de Mercado Pago.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-337">
          2. Uso de la información
        </h3>
        <p data-id="element-338">Utilizamos tu información exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-339">
          <li data-id="element-340">Procesar tu compra y entregar el producto digital.</li>
          <li data-id="element-341">Enviar el material adquirido a tu correo electrónico.</li>
          <li data-id="element-342">Brindarte soporte en caso de ser necesario.</li>
        </ul>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-343">
          3. Protección de datos
        </h3>
        <p data-id="element-344">
          No compartimos, vendemos ni alquilamos tu información personal a
          terceros. Los pagos son procesados de forma segura por Mercado Pago, y
          no almacenamos datos de tarjetas de crédito o débito.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-345">4. Cookies</h3>
        <p data-id="element-346">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia de
          navegación. Podés desactivarlas desde la configuración de tu
          navegador.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-347">5. Tus derechos</h3>
        <p data-id="element-348">
          Podés solicitar la eliminación de tus datos personales en cualquier
          momento enviando un correo a nuestro equipo de soporte.
        </p>
      </LegalModal>

      {/* TERMS OF SERVICE MODAL */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-349">
        <p data-id="element-350">
          <strong data-id="element-351">Última actualización:</strong> Marzo 2026
        </p>

        <p data-id="element-352">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptás los siguientes términos y condiciones.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-353">
          1. Producto digital
        </h3>
        <p data-id="element-354">
          El Método Reset 24h y sus bonos son productos digitales en formato
          PDF. Una vez realizada la compra, recibirás el acceso al material a
          través de tu correo electrónico de forma inmediata.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-355">
          2. Garantía de satisfacción
        </h3>
        <p data-id="element-356">
          Ofrecemos una garantía de devolución de 7 días desde la fecha de
          compra. Si no estás satisfecho con el producto, podés solicitar un
          reembolso completo sin preguntas.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-357">
          3. Propiedad intelectual
        </h3>
        <p data-id="element-358">
          Todo el contenido del Método Reset 24h, incluyendo textos, diseños y
          materiales complementarios, es propiedad exclusiva de NuvoraPlus.
          Queda prohibida su reproducción, distribución o reventa sin
          autorización expresa.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-359">4. Uso personal</h3>
        <p data-id="element-360">
          El material adquirido es para uso personal y no puede ser compartido,
          redistribuido ni utilizado con fines comerciales.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-361">5. Pagos</h3>
        <p data-id="element-362">
          Todos los pagos se procesan de forma segura a través de Mercado Pago.
          NuvoraPlus no almacena información financiera de los usuarios.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-363">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-364">
          El Método Reset 24h es una guía práctica basada en técnicas de
          comunicación y gestión emocional. No reemplaza el asesoramiento
          profesional de un terapeuta o psicólogo. Los resultados pueden variar
          según cada persona y situación.
        </p>

        <h3 className="font-bold text-[#2C3E50] text-base" data-id="element-365">
          7. Modificaciones
        </h3>
        <p data-id="element-366">
          NuvoraPlus se reserva el derecho de modificar estos términos en
          cualquier momento. Las modificaciones serán efectivas desde su
          publicación en el sitio web.
        </p>
      </LegalModal>
    </>;
}